import { useState, useEffect } from "react";
import "./RoleManagement.css";
import { fetchRoles } from "../../services/authService";
import Sidebar from "../shared/Sidebar";
import Header from "../shared/Header";
import { useTheme } from "../../contexts/ThemeContext";
import { getItem, logout } from "../../utils/authStorage";
import LoadingSpinner from "../shared/LoadingSpinner";


function RoleManagement() {
  const [deviceData, setDeviceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const username = getItem("username");
  const role = (getItem("role") || "operator").toLowerCase();
  const { isDarkMode } = useTheme();

  const handleSignOut = () => {
    logout();
  };

  const hasRoleFn = (allowedRoles) => {
    const storedRole = (getItem("role") || '').toLowerCase();
    return allowedRoles.flat().some(r => typeof r === 'string' && r.toLowerCase() === storedRole);
  };


  useEffect(() => {
    async function loadRoles() {
      try {
        const data = await fetchRoles();
        setDeviceData(data);
      } catch (err) {
        console.error("Failed to fetch users detail:", err);
      } finally {
        setLoading(false);
      }
    }
    loadRoles();
  }, []);

  return (
    <div className={`role-management-page ${isDarkMode ? "dark" : "light"}`}>
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(prev => !prev)}
        isDarkMode={isDarkMode}
        username={username}
        role={role}
        onLogout={handleSignOut}
        hasRole={hasRoleFn}
      />

      <div className="main-content">
        <Header title="Role Management" />
        <div className="main-divider" />

        <div className="role-page-container">
          <div className="role-list">
            <div className="page-header">
              <div className="header-left">
                <h3 className="role-list-title">Manage roles</h3>
                <p className="role-list-subtitle">Manage system user roles and security permissions</p>
              </div>
            </div>

            {loading ? (
              <LoadingSpinner message="Loading role details..." />
            ) : !deviceData || deviceData.length === 0 ? (
              <p style={{ padding: "20px", textAlign: "center" }}>No user data found.</p>
            ) : (
              <div className="role-table-wrapper">
                <table className="role-table">
                  <thead>
                    <tr>
                      <th style={{ width: "8%" }}>Id</th>
                      <th style={{ width: "22%" }} className="center">Role</th>
                      <th style={{ width: "70%" }}>Permissions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deviceData.map((role) => (
                      <tr key={role.id}>
                        <td>{role.id}</td>
                        <td className="center">
                          <span className={`role-badge ${role.name.toLowerCase() === "admin" ? "role-admin" : "role-operator"}`}>
                            {role.name.toLowerCase()}
                          </span>
                        </td>
                        <td>
                          <div className="permission-badges-group">
                            {role.permissions && role.permissions.length > 0 ? (
                              role.permissions.map((p, idx) => {
                                const permText = p === 1 ? "Full Access" : p === 2 ? "View Access" : "Unknown";
                                const permClass = p === 1 ? "perm-full" : p === 2 ? "perm-view" : "perm-unknown";
                                return (
                                  <span key={idx} className={`permission-badge ${permClass}`}>
                                    {permText}
                                  </span>
                                );
                              })
                            ) : (
                              <span className="permission-badge perm-none">No permissions</span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoleManagement;
